<template>
  <meta-overlay v-model="isVisible" append-to-body close-by-mark transition="tra-scaleIn">
    <div class="member-bg" @click.stop>
      <img class="close-icon" src="@@/assets/imgs/detail_close.png" @click="close" />
      <div class="title">提示</div>
      <div class="content">需要开启会员才能领取</div>
      <div class="footer">
        <div class="confirm" @click="confirm">去开通会员</div>
      </div>
    </div>
  </meta-overlay>
</template>
<script lang="ts" setup>
import { ref } from "vue";

const isVisible = ref<boolean>(false);

/**
 * @description 去开通会员
 * @return {void}
 */
const confirm = (): void => {
  navManager.open(55, {
    type: "__blank"
  });
  close();
};

/**
 * @description 关闭弹窗
 * @return {void}
 */
const close = (): void => {
  isVisible.value = false;
};

/**
 * @description 打开弹窗
 * @return {void}
 */
const open = (): void => {
  isVisible.value = true;
};

defineExpose({
  open,
  close
});
</script>
<style scoped lang="scss">
.member-bg {
  width: 13.25rem;
  background: #fff;
  position: relative;
  border-radius: 0.5rem;

  .close-icon {
    width: 0.9rem;
    height: 0.9rem;
    position: absolute;
    top: 0.6rem;
    right: 0.6rem;
  }

  .title {
    margin: 0.65rem 0 1.24rem 0;
    text-align: center;
    font-size: 0.685rem;
    font-weight: 600;
  }

  .content {
    color: #000;
    font-size: 0.685rem;
    font-weight: 600;
    text-align: center;
  }

  .footer {
    font-size: 0.7rem;
    display: flex;
    justify-content: center;

    .confirm {
      height: 1.68rem;
      line-height: 1.68rem;
      width: 50%;
      background: #ff7210;
      color: #fff;
      text-align: center;
      border-radius: 1rem;
      margin: 1.3rem 0 0.88rem 0;
    }
  }
}
</style>
